import React, { useState } from "react";
import { FaArrowLeft, FaSignInAlt } from "react-icons/fa";
import { FiInfo } from "react-icons/fi";
import { Link } from "react-router-dom";
import AuthLayout from "../../components/Layouts/AuthLayout";
import { RouteNames } from "../../constants";
import SentIcon from "../../assets/icons/sent-icon.png";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { forgotPassword } from "../../redux/auth/authSlice";
import LoadingSpinner from "../../components/LoadingSpinner";

const ForgetPassword = () => {
  const [forgetPasswordStep, setForgetPasswordStep] = useState(0);
  const dispatch = useAppDispatch();
  const { isLoading, isSuccessful } = useAppSelector((state) => state?.auth);

  const submitForgetPasswordForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setForgetPasswordStep(1);
  };

  const { handleSubmit, setValue, register } = useForm({
    defaultValues: {
      username: "",
      mobileNumber: "",
    },
  });

  const onSubmit = (values: any, e: any) => {
    e.preventDefault();
    dispatch(forgotPassword(values));
    if (isSuccessful) {
      setForgetPasswordStep(1);
    }
  };

  return (
    <AuthLayout>
      {forgetPasswordStep === 0 ? (
        <div className="login forget-password">
          <div className="login_form">
            <Link to={RouteNames.LOGIN} className="btn btn-text">
              <FaArrowLeft className="mr-2" />
              Back
            </Link>
            <h1 className="login_form_head">Forgot Password</h1>
            <div className="login_form_text">
              Enter credentials below to recall password.
            </div>
            <form className="pb-8" onSubmit={submitForgetPasswordForm}>
              <div className="input_container">
                <label className="input_title" htmlFor="email">
                  Username or Email Address
                </label>
                <input
                  id="email"
                  className="input_field"
                  type="text"
                  placeholder={"Enter email address or Username"}
                  disabled={isLoading}
                  {...register("username")}
                />
              </div>
              <div className="input_container">
                <label className="input_title" htmlFor="password">
                  Mobile Number
                </label>
                <div className="input_password_cage">
                  <input
                    id={"mobile-number"}
                    className="input_field"
                    type={"text"}
                    placeholder={"Enter mobile number"}
                    disabled={isLoading}
                    {...register("mobileNumber")}
                  />
                </div>
              </div>

              <button
                onClick={handleSubmit(onSubmit)}
                className="btn btn-primary btn-primary-full"
                style={{ backgroundColor: "#305F32" }}
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? <LoadingSpinner /> : "Submit"}
              </button>
            </form>
          </div>
        </div>
      ) : (
        <></>
      )}
      {forgetPasswordStep === 1 ? (
        <div className="login forget-password2">
          <div className="flex justify-end">
            <Link to={RouteNames.LOGIN} className="btn btn-outline">
              <FaSignInAlt className="mr-2" />
              Login
            </Link>
          </div>
          <div className="login_form">
            <div>
              <img src={SentIcon} alt="" />
            </div>
            <h2 className="login_form_head">
              Check your inbox and confirm your email address
            </h2>
            <div className="login_form_text">
              We've sent a password reset link to your email address
            </div>
            <div className="info_box">
              <div className="info_box_head">
                <span className="text-2xl">
                  <FiInfo className="mr-2" />
                </span>
                Didn't receive an email?
              </div>
              <div className="info_box_text">
                If you can't find the email in your inbox or spam folder, please
                click below and we will send you a new one.
              </div>
            </div>
            <div>
              <button className="btn btn-primary-alt">Resend Email</button>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </AuthLayout>
  );
};

export default ForgetPassword;
